module.exports = __webpack_public_path__ + "static/media/male-user-shadow.1f82dd38.svg";